import HighlightPhraseFilter from './HighlightPhraseFilter';
import prettyPhoneNumber from './prettyPhoneNumber';

export default angular.module('edge.platform.filters', [
    'edge.platform.l10n'
])
    .filter('highlightPhrase', HighlightPhraseFilter)
    .filter('gwPrettyPhoneNumber', prettyPhoneNumber);

